export const isSpotlightEnabled = true;
